import * as React from "react";
const BotCuiratoIconSvg = (props) => (
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_720_1853)">
      <path
        d="M35.1642 0H9.63733C4.32543 0 0.0192871 4.30615 0.0192871 9.61805V35.1449C0.0192871 40.4568 4.32543 44.7629 9.63733 44.7629H35.1642C40.4761 44.7629 44.7822 40.4568 44.7822 35.1449V9.61805C44.7822 4.30615 40.4761 0 35.1642 0Z"
        fill="#670000"
      />
      <path
        d="M23.1911 34.0071C22.7479 34.0071 22.3708 33.6962 22.3708 33.3059V23.7144C22.3708 23.3373 22.7479 23.0132 23.1911 23.0132C23.6343 23.0132 24.0113 23.3373 24.0113 23.7144V33.3059C24.0113 33.6962 23.6541 34.0071 23.1911 34.0071Z"
        fill="#FCF0D7"
      />
      <path
        d="M29.7001 34.0071C29.2569 34.0071 28.8799 33.6962 28.8799 33.3059V23.7144C28.8799 23.3373 29.2569 23.0132 29.7001 23.0132C30.1433 23.0132 30.5204 23.3373 30.5204 23.7144V33.3059C30.5204 33.6962 30.1632 34.0071 29.7001 34.0071Z"
        fill="#FCF0D7"
      />
      <path
        d="M36.2158 34.0071C35.7726 34.0071 35.3955 33.6962 35.3955 33.3059V23.7144C35.3955 23.3373 35.7726 23.0132 36.2158 23.0132C36.659 23.0132 37.036 23.3373 37.036 23.7144V33.3059C37.036 33.6962 36.6788 34.0071 36.2158 34.0071Z"
        fill="#FCF0D7"
      />
      <path
        d="M16.186 17.8998C17.1584 14.6982 20.0425 12.3698 23.4359 12.3698C26.0488 12.3698 28.45 13.7457 29.8589 16.041C30.0905 16.4181 30.5469 16.557 30.9239 16.3586C31.6648 15.9815 32.452 15.7897 33.259 15.7897C34.8003 15.7897 36.1894 16.4776 37.1552 17.6154C37.7902 18.3629 39.219 18.1975 38.789 16.934C37.5124 15.1679 35.475 14.0698 33.259 14.0698C32.624 14.0698 31.9956 14.1624 31.387 14.341L30.8578 14.4998L30.5006 14.0632C28.7476 11.8935 26.1745 10.6499 23.4359 10.6499C19.6588 10.6499 16.3315 13.0643 14.9093 16.557C14.8233 16.7753 14.7373 16.9936 14.6645 17.2185C14.4793 17.8006 15.9478 18.6473 16.1727 17.8998H16.186Z"
        fill="#FCF0D7"
      />
      <path
        d="M13.4409 31.7912C12.4222 31.7912 11.4432 31.5928 10.5171 31.1892C9.64392 30.8056 8.84352 30.283 8.15557 29.5884C7.46762 28.9137 6.93843 28.1199 6.55477 27.2269C6.15787 26.3207 5.97266 25.3549 5.97266 24.3759C5.97266 23.3969 6.1711 22.4179 6.55477 21.5051C6.93843 20.6319 7.48085 19.8315 8.1688 19.1634C8.85675 18.4754 9.67699 17.9462 10.5634 17.5626C11.4895 17.1789 12.4685 16.9805 13.4673 16.9805C15.1012 16.9805 16.6292 17.4898 17.8993 18.4688C18.2962 18.7797 18.369 19.342 18.0779 19.7389C17.767 20.1358 17.1849 20.2085 16.8078 19.9175C15.8487 19.17 14.7043 18.7929 13.4673 18.7929C12.7066 18.7929 11.9591 18.9385 11.2513 19.2295C10.5766 19.5206 9.96143 19.9175 9.43224 20.4467C8.90305 20.9759 8.50616 21.5514 8.2151 22.2261C7.92405 22.9008 7.77852 23.6218 7.77852 24.3693C7.77852 25.1168 7.92405 25.8246 8.2151 26.5125C8.50616 27.1872 8.90305 27.7826 9.43224 28.2919C10.5039 29.3635 11.9194 29.9655 13.4276 29.9655C14.1024 29.9655 14.3008 31.7846 13.4276 31.7846L13.4409 31.7912Z"
        fill="#FCF0D7"
      />
      <path
        d="M18.0777 29.9917H13.315C12.8766 29.9917 12.5212 30.3471 12.5212 30.7855V30.9972C12.5212 31.4356 12.8766 31.7909 13.315 31.7909H18.0777C18.5161 31.7909 18.8715 31.4356 18.8715 30.9972V30.7855C18.8715 30.3471 18.5161 29.9917 18.0777 29.9917Z"
        fill="#FCF0D7"
      />
    </g>
    <defs>
      <clipPath id="clip0_720_1853">
        <rect
          width="44.7629"
          height="44.7629"
          fill="white"
          transform="translate(0.0192871)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default BotCuiratoIconSvg;
